import axios from 'axios';
import _snakeCase from 'lodash/snakeCase';
import { titleCase } from 'Services/utils';
const CREPO_API_URL = process.env.REACT_APP_CREPO_API_URL;
const CREPO_API_KEY = process.env.REACT_APP_CREPO_API_KEY;

const CREPO_REQ_HEADERS = {
  headers: {
    'API-Key': CREPO_API_KEY,
  },
};

const TYPE_FIELDS = {
  EVENT_PROFILE: `
    endDate {
      dateTimeUTC
    }
    locations {
      location {
        city
        countryName
        flagUrl
        state
      }
    }
    liveStatus
    startDate {
      dateTimeUTC
    }
    status
    statusMessage
  `,
  EVENT_SERIES: `
    endDate {
      dateTimeUTC
    }
    locations {
      location {
        city
        countryName
        flagUrl
        state
      }
    }
    startDate {
      dateTimeUTC
    }
  `,
  FILM: 'videoDurationSeconds',
  SHOW: `
    episodes {
      id
    }
    seasons {
      id
    }
  `,
  VIDEO: 'videoDurationSeconds',
};

const typeQueryAttrs = (type) => `
  ...on ${titleCase(type)} {
    ${TYPE_FIELDS[type]}
  }`;

const resourceQuery = () => {
  return `
    id
    __typename
    title {
      text
    }
    subHeading {
      text
    }
    teaser {
      text
    }
    url {
      href
    }
    tags(first: 1) {
      title {
        text
      }
    }
    geoBlockedIn
    featuredMedia(first: 1) {
      ...on Image {
        imageSrc(mode: scale, width: ${600}, aspectRatio: ${2 / 3})
      }
    }
    ${Object.keys(TYPE_FIELDS).map((key) => {
      return typeQueryAttrs(key);
    })}
  `;
};

const queryResources = ({ ids, locale }) => {
  return `{
    resources(
      ids: [${ids}]
		  includeDraft: false
      includeUnpublished: false
      localeMixing: ["${locale}", "${locale.split('-')[0]}", "en-INT", "en"]
      enforceGeoBlocking: false
    ) {
      ${resourceQuery()}
    }
  }`;
};

const resolveResource = ({
  id,
  __typename,
  title,
  subHeading,
  teaser,
  url,
  tags,
  featuredMedia,
  geoBlockedIn,
  seasons,
  episodes,
  videoDurationSeconds,
  liveStatus,
  status,
  statusMessage,
  endDate,
  startDate,
  locations,
}) => ({
  id,
  type: (__typename && _snakeCase(__typename).toUpperCase()) || '',
  title: title?.text ?? '',
  subHeading: subHeading?.text ?? '',
  teaser: teaser?.text ?? '',
  url: url?.href ?? '',
  tag: tags?.[0]?.title?.text ?? '',
  imageSrc: featuredMedia?.[0]?.imageSrc ?? '',
  geoBlockedIn: geoBlockedIn || [],
  seasonCount: seasons?.length ?? 0,
  episodeCount: episodes?.length ?? 0,
  videoDurationSeconds: videoDurationSeconds ?? 0,
  liveStatus: liveStatus ?? '',
  status: status ?? '',
  statusMessage: statusMessage ?? '',
  endDate: endDate?.dateTimeUTC ?? '',
  startDate: startDate?.dateTimeUTC ?? '',
  location: {
    city: locations?.[0]?.location?.city ?? '',
    country: locations?.[0]?.location?.countryName ?? '',
    flagUrl: locations?.[0]?.location?.flagUrl ?? '',
    state: locations?.[0]?.location?.state ?? '',
  },
});

const getHydratedContent = async ({ cancelToken, locale, ids }) => {
  const { data } = await axios.post(
    `${CREPO_API_URL}/v1/graphql`,
    {
      query: `${queryResources({
        ids,
        locale,
      })}`,
    },
    {
      cancelToken,
      ...CREPO_REQ_HEADERS,
    }
  );
  const { resources } = data.data;
  return resources.map(resolveResource);
};

export { getHydratedContent, resolveResource, queryResources };
